import axios from "axios";
import * as Config from "../../config";

const state = {
	invoices: {},
	invoice: {},
};

const actions = {
	get_clients_emmited({ commit, dispatch }, userId) {
		return new Promise((resolve, reject) => {
			axios
				.get(Config.apiPath + "invoice/get-clients-emmited/" + userId)
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					console.log('rejecterror');
					reject(error);
				});
		});
	},
	load_Invoice({ commit, dispatch }, form) {
		return new Promise((resolve, reject) => {
			axios
				.get(Config.apiPath + "invoice/consult/" + form.id)
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					reject(error.response.data);
				});
		});
	},
	
	get_Last_invoice({ commit, dispatch }, form) {
		return new Promise((resolve, reject) => {
			axios
				.get(Config.apiPath + "invoice/get_last_invoice/" + form.id_user + "/billing/" + form.billing)
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					reject(error.response.data);
				});
		});
	},

	send_invoice({ commit, dispatch }, form) {
		return new Promise((resolve, reject) => {
			axios
				.post(Config.apiPath + "invoice/new_invoice_v2", form)
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {

					reject(error.response.data);
				});
		});
	},
	changeStatus_Invoice({ commit, dispatch }, form) {
		return new Promise((resolve, reject) => {
			axios
				.put(Config.apiPath + "invoice/change/status/" + form.id + "/" + form.status)
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					reject(error.response.data);
				});
		});
	},
	update_InvoiceDetails({ commit, dispatch }, form) {
		return new Promise((resolve, reject) => {
			axios
				.post(Config.apiPath + "invoice/update/details", form)
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	delete_Invoice({ commit, dispatch }, form) {
		return new Promise((resolve, reject) => {
			axios
				.put(Config.apiPath + "invoice/change/active/" + form.id + "/" + form.active)
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					reject(error.response.data);
				});
		});
	},
	invoice_dispatchGet2({ commit, dispatch }, form) {
		return new Promise((resolve, reject) => {
			axios
				.post(Config.apiPath + "invoice/dispatch-get-2", { cuit: form.cuit })
				.then((response) => {
					resolve(response.data);
				})
				.catch((error) => {
					reject(error.response.data);
				});
		});
	},
	invoice_pdf({ commit, dispatch }, form) {
		return new Promise((resolve, reject) => {
			axios
				.get(Config.apiPath + "invoice/pdf/" + form.authCode + (form.leyenda ? '?leyenda=true' : ''), {
					responseType: 'blob' // Indicamos que esperamos una respuesta binaria
				})
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error.response);
				});
		});
	},
	invoice_pdf_image({ commit, dispatch }, authCode) {
		return new Promise((resolve, reject) => {
			axios
				.get(Config.apiPath + "invoice/pdf/" + authCode + '?ticket=13', {
					responseType: 'blob' // Indicamos que esperamos una respuesta binaria
				})
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error.response);
				});
		});
	},
};

const mutations = {};

export default {
	state,
	actions,
	mutations,
};
